import { gatewayHttpClient, gatewayServiceClient } from '@/infrastructure/http/httpClient';

import { IClearanceRole } from '../interfaces/accessControl';
import { IPartnerListItem, IWhoamiResponse } from '../interfaces/user';

class AuthRepository {
  async whoami(): Promise<IWhoamiResponse | null> {
    const response = await gatewayHttpClient.get<IWhoamiResponse>('/auth/whoami');

    if (!response.partnerId) {
      return null;
    }

    return response;
  }

  async getPartnersList(): Promise<Array<IPartnerListItem>> {
    return gatewayHttpClient.get<Array<IPartnerListItem>>('/users/partners/list');
  }

  /**
   * The partner's role catalog, which is where a role name becomes text a person can read.
   * Scoped to the partner: the same account switching partners gets a different catalog.
   */
  async getUserClearanceRoles(partnerId: string): Promise<Array<IClearanceRole>> {
    const roles = await gatewayServiceClient('admin').get<Array<IClearanceRole>>(
      `/settings/clearance-roles/${partnerId}`,
    );

    return Array.isArray(roles) ? roles : [];
  }

  async switchPartner(partnerId: string): Promise<IWhoamiResponse> {
    return gatewayHttpClient.patch<IWhoamiResponse>('/users/partners/switch', {
      body: { partnerId },
    });
  }
}

export const authRepository = new AuthRepository();
